import { AddNewTransaction } from "@/components/modals/AddNewTransaction";
import { ChangeBillingInfo } from "@/components/modals/ChangeBillingInfo";
import { ChangeMembership } from "@/components/modals/ChangeMembership";
import { ChangePassword } from "@/components/modals/ChangePassword";
import { ChangePaymentMethod } from "@/components/modals/ChangePaymentMethod";
import { CreateNewEstate } from "@/components/modals/CreateNewEstate";
import { CreateNewWatchDog } from "@/components/modals/CreateNewWatchDog";
import { DeleteAccount } from "@/components/modals/DeleteAccount";
import { Support } from "@/components/modals/Support";
import { SwitchUsers } from "@/components/modals/SwitchUsers";
import { Dialog } from "@/components/ui/Dialog";
import { useAppContext } from "@/context/AppContext";
import { useMenuItemsContext } from "@/context/MenuItemsContext";
import { useEstateContext } from "@/context/EstateContext";
import { hasReachedEstateLimit } from "@/utils/membershipLimits";

const ModalWindows = () => {
  const { isOpen, setIsOpen, selectedItem } = useMenuItemsContext();
  const { userInfoGlobal } = useAppContext();
  const { allEstateList } = useEstateContext();
  const selectedName = selectedItem?.name;
  const isSelected = (...names: string[]) =>
    selectedName ? names.includes(selectedName) : false;

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      {isSelected("Smazat účet", "Delete account") ? (
        <DeleteAccount />
      ) : isSelected("Změnit členství", "Change membership") ? (
        <ChangeMembership />
      ) : isSelected("Změnit platební údaje", "Change payment details") ? (
        userInfoGlobal?.membership === "BASIC" ? (
          <ChangeMembership />
        ) : (
          <ChangePaymentMethod />
        )
      ) : isSelected("Změnit heslo", "Change password") ? (
        <ChangePassword />
      ) : isSelected("Změnit fakturační údaje", "Change billing details") ? (
        <ChangeBillingInfo />
      ) : isSelected("Vytvořit nového", "Create new") ? (
        <CreateNewWatchDog />
      ) : isSelected("Spravovat existujícího", "Manage existing") ? (
        <CreateNewWatchDog />
      ) : isSelected("Přepnout uživatele", "Switch user") ? (
        <SwitchUsers />
      ) : isSelected("Přidat nemovitost", "Add property") ? (
        hasReachedEstateLimit(
          allEstateList.length,
          userInfoGlobal?.membership,
        ) ? (
          <ChangeMembership />
        ) : (
          <CreateNewEstate />
        )
      ) : isSelected("Upravit nemovitost", "Edit property") ? (
        <CreateNewEstate />
      ) : isSelected("Přidat transakci", "Add transaction") ? (
        <AddNewTransaction />
      ) : isSelected(
          "Nahlásit chybu",
          "Report a bug",
          "Požádat o novou funkci",
          "Request a new feature",
        ) ? (
        <Support />
      ) : null}
    </Dialog>
  );
};

export default ModalWindows;
